import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormsModule, UntypedFormControl } from '@angular/forms'
import { NbFormFieldModule, NbInputModule } from '@nebular/theme'

/**
 * Component that represents a single form value
 */
@Component({
  selector: 'ngx-personas-form-element-value',
  templateUrl: './form-element-value.component.html',
  styleUrls: ['./form-element-value.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, NbFormFieldModule, NbInputModule]
})
export class FormElementValueComponent implements OnInit {
  /** value name control */
  @Input() name: UntypedFormControl
  /**  value name changed */
  @Output()
  nameChange: EventEmitter<UntypedFormControl> = new EventEmitter<UntypedFormControl>()

  /** value slug control */
  @Input() slug: UntypedFormControl
  /** value slug changed */
  @Output()
  slugChange: EventEmitter<UntypedFormControl> = new EventEmitter<UntypedFormControl>()

  /** Enter key was pressed */
  @Output()
  enterPressed: EventEmitter<boolean> = new EventEmitter<boolean>()

  /** value id */
  @Input()
  id = ''
  /** Other values slugs */
  @Input() slugs: string[]
  /** Creates the component */
  constructor() {}
  /** bootstraps the component */
  ngOnInit() {}

  /** Updates the current changed property */
  update(property, value) {
    if (!value) return
    const moreThanOneSpaceRegex = / {2,}/g
    value = value.replace(moreThanOneSpaceRegex, ' ').trim()
    this.name.patchValue(value)
    this[property].patchValue(value)
    this[property + 'Change'].emit(this[property])
    if (this.slug.value === '') this.update('slug', value)
  }
  /** Checks whether the current slug is in use */
  slugAlreadyInUse(): boolean {
    return this.slugs.filter((_slug) => this.slug.value === _slug).length > 1
  }
}
